import React from 'react';
import UHC_BoxPipesAndValues, { BoxPipesAndValuesProps } from './BoxPipesAndValues/BoxPipesAndValues';
import UHC_SlideButton, { SlideButtonProps } from './SlideButton/SlideButton';
import UHC_InputRange, { InputRangeProps } from './InputRange/InputRange';
import { SC_Slider } from './Slider.styled';
import { UHCTooltipSliderProps } from '../../Atoms/TooltipSlider/TooltipSlider';
import { SliderColorsOptions } from './sliderColors';


export interface Pipes {
    value:string,
    tooltip?:UHCTooltipSliderProps['children']
}



export interface UHC_SliderProps {
    ['aria-labelledBy']: string
    pipes: Pipes[];
    pipesDisabled?: {
        min: number,
        max: number
    },
    pipeState: {
        pipeSelected: number,
        setPipeSelected: (value: number) => void,
    },
    color: SliderColorsOptions
}

const UHC_Slider: React.FC<UHC_SliderProps> = (props: UHC_SliderProps) => {
    const {color, pipes, pipeState, pipeState: { pipeSelected }, pipesDisabled } = props;
    const sizeBullet = 35;
    const sizePipe = 1;
    const boxPipesAndValuesProps: BoxPipesAndValuesProps = { color, pipes, pipeSelected, sizePipe, pipesDisabled}
    const inputRangeSlide: InputRangeProps = { pipes, pipeState, pipesDisabled, 'aria-labelledBy': props['aria-labelledBy'] };
    const slideButtonProps: SlideButtonProps = {
        pipeSelected, pipes,
        sizes: {
            button: sizeBullet,
            pipe: sizePipe
        },
        color
    };
    return (
        <SC_Slider data-testid='UHC_Slider'>
            <UHC_BoxPipesAndValues  {...boxPipesAndValuesProps} />
            <UHC_SlideButton {...slideButtonProps} />
            <UHC_InputRange {...inputRangeSlide} />
        </SC_Slider>
    );
}

export default UHC_Slider;